module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Minus-a9c394986da444a9cfed88dac76ea419.svg";